import HttpService from "@core/services/http/http.service";
import { GetDetailResponse, GetListResponse } from "@app/types";
import { RequestParams, Signal } from "@core/services/http/http.type";
import {
  Advertise,
  CreateAdvertise,
  UpdateAdvertise,
} from "@app/types/advertise.type";

class _AdcertiseService {
  public getList(requestParams?: RequestParams, signal?: Signal) {
    return HttpService.get<GetListResponse<Advertise>>(
      "/admin/api/v2/advertises",
      {
        queryParams: { ...requestParams },
        signal,
      }
    );
  }

  public get(advertiseId: number) {
    return HttpService.get<GetDetailResponse<Advertise>>(
      `/admin/api/v2/advertises/${advertiseId}`
    );
  }

  public create(createAdvertise: CreateAdvertise) {
    return HttpService.post("/admin/api/v2/advertises", {
      body: { ...createAdvertise },
    });
  }

  public update(advertiseId: number, updateAdvertise: UpdateAdvertise) {
    return HttpService.patch(`/admin/api/v2/advertises/${advertiseId}`, {
      body: { ...updateAdvertise },
    });
  }

  public delete(advertiseId: number) {
    return HttpService.delete(`/admin/api/v2/advertises/${advertiseId}`);
  }
}

const AdvertiseService = new _AdcertiseService();

export default AdvertiseService;
